const getYearAndQuarter = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-indexed

  // Current quarter (1-indexed)
  const currentQuarter = Math.ceil((currentMonth + 1) / 3);

  const years = [currentYear - 2, currentYear - 1, currentYear];
  const quarters = ["Q1", "Q2", "Q3", "Q4"];

  const result = [];

  years.forEach((year) => {
    quarters.forEach((quarter) => {
      const quarterNum = parseInt(quarter.replace("Q", ""));

      // For current year, only include quarters up to the current quarter
      if (year === currentYear && quarterNum > currentQuarter) return;

      result.push({
        label: `${year} ${quarter}`,
        value: `${year}_${quarter}`,
      });
    });
  });

  return result;
}

const getYears = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const years = [currentYear - 2, currentYear - 1, currentYear];

  const result = [];

  years.forEach((year) => {
    result.push({
      label: String(year),
      value: year,
    });
  });

  return result;
}

export const enums = {
  // Employee/Resource service types
  type_of_service: [
    { label: "Full Time", value: "FULL_TIME" },
    { label: "Contractual", value: "CONTRACTUAL" },
    { label: "External Vendor", value: "EXTERNAL_VENDOR" },
  ],

  // Skill proficiency levels
  proficient_level: [
    { label: "Level 1", value: "LEVEL_1" },
    { label: "Level 2", value: "LEVEL_2" },
    { label: "Level 3", value: "LEVEL_3" },
    { label: "Professional Expert", value: "PROFESSIONAL_EXPERT" },
  ],

  // Project status codes
  project_status_code: [
    { label: "New", value: "PENDING" },
    { label: "In Progress", value: "IN_PROGRESS" },
    { label: "Complete", value: "COMPLETED" },
    { label: "On Hold", value: "ON_HOLD" },
    { label: "Delayed", value: "REJECTED" },
  ],

  // Project priority codes
  project_priority_code: [
    { label: "Low", value: "LOW" },
    { label: "Medium", value: "MEDIUM" },
    { label: "High", value: "HIGH" },
    { label: "Critical", value: "CRITICAL" },
  ],

  // Supported currency codes
  currency_code: [
    { label: "Indian Rupee", value: "INR" },
    { label: "US Dollar", value: "USD" },
  ],

  // Project types
  project_type: [
    { label: "Billable", value: "BILLABLE" },
    { label: "Non-Billable", value: "NON_BILLABLE" },
    // { label: "Support", value: "SUPPORT" },
    { label: "Internal", value: "INTERNAL" }
  ],

  tag_type: [
    { label: "Business", value: "BUSINESS" },
    { label: "Internal", value: "INTERNAL" },
    { label: "Support", value: "SUPPORT" }
  ],

  // Project contract models
  project_model: [
    { label: "Fixed Scope", value: "FIXED_PRICE_CONTRACT" },
    { label: "Flexible Service", value: "TIME_AND_MATERIAL_CONTRACT" },
    // { label: "Cost Reimbursable Contract", value: "COST_REIMBURSABLE_CONTRACT" },
    // { label: "Dedicated Teams", value: "DEDICATED_TEAMS" },
    { label: "Fixed Term Employee", value: "FTE" },
    { label: "Internal/Support", value: "OTHER" },
  ],

  // Project risk types
  risk: [
    { label: "Budget Overrun", value: "BUDGET_OVERRUN" },
    { label: "Technical Challenge", value: "TECH_CHALLENGE" },
    { label: "Resource Constraint", value: "RESOURCE_CONSTRAINT" },
  ],

  // Communication types
  communication: [
    { label: "Weekly Standup", value: "WEEKLY_STANDUP" },
    { label: "Monthly Report", value: "MONTHLY_REPORT" },
    { label: "Quarterly Stakeholder Review", value: "QUARTERLY_STAKEHOLDER_REVIEW" },
    { label: "Daily Standup", value: "DAILY_STANDUP" },
  ],

  // Milestone status codes
  milestone_status_code: [
    { label: "Planned", value: "PLANNED" },
    { label: "In Progress", value: "IN_PROGRESS" },
    { label: "Complete", value: "COMPLETE" },
  ],

  // Deliverable status codes
  deliverable_status_code: [
    { label: "In Progress", value: "IN_PROGRESS" },
    { label: "Complete", value: "COMPLETE" },
  ],

  // Task status codes
  task_status_code: [
    { label: "Planned", value: "TO_DO" },
    { label: "In Progress", value: "IN_PROGRESS" },
    { label: "Completed", value: "COMPLETED" },
    { label: "On Hold", value: "ON_HOLD" },
  ],

  // Task priority codes
  task_priority_code: [
    { label: "Low", value: "LOW" },
    { label: "Medium", value: "MEDIUM" },
    { label: "High", value: "HIGH" },
    { label: "Critical", value: "CRITICAL" },
  ],

  // Timesheet status codes
  timesheet_status_code: [
    { label: "Pending", value: "PENDING" },
    { label: "Approved", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
  ],

  // Report status codes
  report_status_code: [
    { label: "Generation In Progress", value: "GENERATION_IN_PROGRESS" },
    { label: "Ready To Download", value: "READY_TO_DOWNLOAD" },
    { label: "Failed To Generate", value: "FAILED_TO_GENERATE" },
  ],

  // Report type codes
  report_type_code: [
    { label: "Client Portfolio Summary", value: "CLIENT_PORTFOLIO_SUMMARY" },
    { label: "Organization Utilization Report", value: "ORGANIZATION_UTILIZATION_REPORT" },
    { label: "Team Utilization Report", value: "TEAM_UTILIZATION_REPORT" },
    { label: "Timesheet Report", value: "TIMESHEET_REPORT" },
    { label: "Compliance Report", value: "COMPLIANCE_REPORT" },
    { label: "Project Health Report", value: "PROJECT_HEALTH" },
    { label: "Resource Utilization Report", value: "RESOURCE_UTILIZATION_REPORT" },
  ],

  // Report type codes
  month_code: [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ],


  // Year and quarter codes
  year_and_quarter: getYearAndQuarter(),

  // Years
  years: getYears(),
};

export default enums;
